import {Dimensions, Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import Feather from 'react-native-vector-icons/Feather';
import {Text, View} from 'react-native-animatable';
import FastImage from 'react-native-fast-image';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.shape};
`;

export const ContainerCamera = styled.View`
  position: absolute;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const ContainerCameraContent = styled.View`
  flex: 1;
  height: 100%;
  justify-content: space-between;
`;

export const InstructionsContainer = styled.View`
  margin-top: ${RFPercentage(16)}px;
  padding: 0 24px;
  z-index: 2;
  background-color: transparent;
  justify-content: center;
  align-items: center;
`;
export const Instruction = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(16)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Footer = styled.View`
  padding: 0 24px;
  justify-content: center;
  align-items: center;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
  z-index: 2;
`;
export const CaptureButton = styled.TouchableOpacity`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${RFValue(6)}px;
`;
export const CaptureButtonCircle = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(50)}px;
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  justify-content: center;
  align-items: center;
`;
export const CaptureButtonIcon = styled(FontAwesome5)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const CaptureInstruction = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  text-align: center;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const SuccessContainer = styled(View)`
  position: absolute;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 0 24px;
  align-items: center;
  z-index: 301;
  background-color: ${({theme}) => theme.colors.shape};
`;

export const SuccessText = styled(Text)`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(18)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const MaskImage = styled(FastImage)`
  position: absolute;
  width: ${Dimensions.get('window').width }px;
  height: ${Dimensions.get('window').height }px;

  z-index: 2;
`;

export const CloseButtonContainer = styled.View`
  z-index: 2;
  position: absolute;
  width: 100%;
  padding: 0 24px;
`;

export const TopControlsRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CloseButton = styled.TouchableOpacity``;

export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(20)}px;
`;

export const ControlButton = styled.TouchableOpacity`
  width: ${RFValue(36)}px;
  height: ${RFValue(36)}px;
  border-radius: ${RFValue(18)}px;
  background-color: rgba(0, 0, 0, 0.45);
  justify-content: center;
  align-items: center;
`;

interface ControlButtonIconProps {
  active?: boolean;
}

export const ControlButtonIcon = styled(Feather)<ControlButtonIconProps>`
  font-size: ${RFValue(18)}px;
  color: ${({active}) => (active ? '#FFD600' : '#fff')};
`;

/* ---------- Focus Indicator ---------- */

export const FocusIndicator = styled.View`
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  border-width: 2px;
  border-color: #FFD600;
  z-index: 10;
`;

/* ---------- Camera Footer ---------- */

export const CameraFooterRow = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${RFValue(20)}px;
`;

export const UploadButton = styled.TouchableOpacity`
  flex-direction: column;
  align-items:center;
  justify-content: center;
  gap: ${RFValue(6)}px;
  position: absolute;

  right: 24px;

`;

export const UploadButtonCircle = styled.View`
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  border-radius: ${RFValue(50)}px;
  background-color: rgba(0, 0, 0, 0.45);
  border:2px solid rgba(255,255,255,0.25);
  justify-content: center;
  align-items: center;
`;


export const UploadButtonIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.shape};
`;

/* ---------- Preview ---------- */

export const PreviewImage = styled.Image`
  position: absolute;
  width: ${Dimensions.get('window').width * 1.4}px;
  height: ${Dimensions.get('window').height * 1.4}px;
  top: ${-(Dimensions.get('window').height * 0.2)}px;
  left: ${-(Dimensions.get('window').width * 0.2)}px;
`;

export const GalleryPreviewWrapper = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  justify-content: center;
  align-items: center;
`;

export const GalleryPreviewImage = styled.Image`
  width: 85%;
  height: 65%;
`;

export const PreviewOverlay = styled.View`
  position: absolute;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  z-index: 3;
`;

export const PreviewButtonsRow = styled.View`
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: ${RFValue(12)}px;
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? RFValue(8)
    : RFValue(24)}px;
`;

interface PreviewButtonProps {
  variant?: 'primary' | 'secondary';
}

export const PreviewButton = styled.TouchableOpacity<PreviewButtonProps>`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${RFValue(16)}px ${RFValue(20)}px;
  border-radius: ${RFValue(12)}px;
  background-color: ${({variant, theme}) =>
    variant === 'primary' ? theme.colors.primary : 'rgba(0, 0, 0, 0.6)'};
  min-height: ${RFValue(52)}px;
`;

export const PreviewButtonText = styled.Text`
  color: #fff;
  font-size: ${RFValue(15)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-left: ${RFValue(8)}px;
`;

export const PreviewButtonIcon = styled(Feather)`
  color: #fff;
  font-size: ${RFValue(20)}px;
`;
